import { render, staticRenderFns } from "./AsfCheckbox.vue?vue&type=template&id=0c2c0489"
import script from "./AsfCheckbox.vue?vue&type=script&lang=js"
export * from "./AsfCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports